import { Routes, Route, useLocation } from "react-router-dom";
import InfoMultiTenantInfraInformationPage from "./Pages/Info/MultiTenant/Index.js";
import Home from "./Pages/Home/Index.js";
import ProvablyFairPage from "./Pages/ProvablyFairSystem/Index.js";
import StartupOperatorsSolutionPage from "./Pages/Operators/Solutions/Index.js";
import { Fragment, useEffect } from "react";
import BookDemoPage from "./Pages/BookADemo/Index.js";
import SweepstakesInfrastructurePage from "./Components/TypesOfCasino/Sweepstakes/Index.js";
import AboutCompanyPage from "./Pages/AboutCompany/Index.js";
import PricingPagePage from "./Pages/Pricing/Index.js";
import OperatorCompanyPage from "./Pages/Company/Index.js";
import OperatorTableGameEnginePage from "./Pages/Info/HowGamesWork/TableGames/HowCardGamesWork.js";
import OperatorFairnessModulePage from "./Pages/Info/Fairness/Index.js";
import OperatorFAQConenctingOfficalPage from "./Pages/Info/FAQ/Index.js";
import OperatorArchitectureWalkthroughHelper from "./Components/Info/ArchitectureWalkthru/Index.js";
import OperatorCareersPage from "./Pages/Careers/Index.js";
import RequestDocumentation from "./Components/Info/Documentation/Request.js";
import RiskManagement from "./Pages/RiskManagement/Index.js";
import OriginalsCustomDevPage from "./Pages/OriginalsCustom/Index.js";
import PublicOperatorDocs from "./Pages/Docs/Public/Index.jsx";
import PrivacyPolicyPage from "./Pages/PrivacyPolicy/Index.js";
import TermsAndConditions from "./Pages/TermsAndConditions/Index.js";

const routes = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: "/company/careers",
    element: <OperatorCareersPage />,
  },
  {
    path: "/privacy/policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms/and/conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/docs",
    element: <PublicOperatorDocs />,
  },
  {
    path: "/company/architecture-walkthrough",
    element: <OperatorArchitectureWalkthroughHelper />,
  },
  {
    path: "/comapny-core/fairness-tools",
    element: <OperatorFairnessModulePage />,
  },
  {
    path: "/company",
    element: <OperatorCompanyPage />,
  },
  {
    path: "/general/frequently-asked-questions",
    element: <OperatorFAQConenctingOfficalPage />,
  },
  {
    path: "/table-games/engines",
    element: <OperatorTableGameEnginePage />,
  },
  {
    path: "/info/multi-tenant/infrastructure",
    element: <InfoMultiTenantInfraInformationPage />,
  },
  {
    path: "/about",
    element: <AboutCompanyPage />,
  },
  {
    path: "/pricing",
    element: <PricingPagePage />,
  },
  {
    path: "/provably-fair-engine",
    element: <ProvablyFairPage />,
  },
  {
    path: "/solutions/startup-operators",
    element: <StartupOperatorsSolutionPage />,
  },
  {
    path: "/solutions/sweepstakes",
    element: <SweepstakesInfrastructurePage />,
  },
  {
    path: "/book-demo",
    element: <BookDemoPage />,
  },
  {
    path: "/request-documentation",
    element: <RequestDocumentation />
  },
  {
    path: "/risk-management",
    element: <RiskManagement />
  },
  {
    path: "/originals-custom",
    element: <OriginalsCustomDevPage />
  }
];

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prevent browser from restoring previous scroll position
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Scroll immediately
    window.scrollTo(0, 0);

    // Scroll again after page content has had time to render
    const timeout = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }, 225);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return (
    <Fragment>
      <Routes>
        <Route path="" element={null}>
          {routes.map((route, i) => (
            <Route
              key={i}
              index={route.index}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
      </Routes>
    </Fragment>
  );
};

export default App;